import { AnalyticsBrowser } from '@segment/analytics-next';
import { analyticsService } from '@/services/AnalyticsService';

export const analytics = AnalyticsBrowser.load({
  writeKey: import.meta.env.VITE_SEGMENT_KEY,
});

const customUtmMiddleware = ({ payload, next }) => {
  if (payload.action() === 'page' && payload.obj.properties.query && _.isEmpty(payload.obj.context.campaign)) {
    const mapUtmFromQueryObject = (queryObject) => {
      return Object.keys(queryObject).reduce((result, key) => {
        if (key.startsWith('utm_') && key.length > 4) {
          let utmParam = key.substring(4);
          if (utmParam === 'campaign') {
            utmParam = 'name';
          }
          result[utmParam] = queryObject[key];
        }
        return result;
      }, {});
    };
    const campaign = mapUtmFromQueryObject(payload.obj.properties.query);

    if (!_.isEmpty(campaign)) {
      // noinspection JSValidateTypes
      payload.obj.context.campaign = campaign;
    }
  }

  next(payload);
};

const commonPropertiesMiddleware = ({ payload, next }) => {
  if (!payload.obj.properties.$os) {
    payload.obj.properties.$os = analyticsService.getOs();
  }

  next(payload);
};

// noinspection JSIgnoredPromiseFromCall
analytics.addSourceMiddleware(customUtmMiddleware);
// noinspection JSIgnoredPromiseFromCall
analytics.addSourceMiddleware(commonPropertiesMiddleware);
